interface SessionOverviewPanelProps extends React.AriaAttributes {
  children: React.ReactNode;
  role?: React.AriaRole;
}

export const SessionOverviewPanel = ({ children, ...panelProps }: SessionOverviewPanelProps) => (
  <div className='flex min-h-[268px] items-center justify-center' {...panelProps}>
    {children}
  </div>
);
